import React, { useMemo, useState, useEffect } from "react"
import { useSelector } from 'react-redux'
import { getGlobalProps } from 'state-management/selectors'
import { useViewport } from 'components/general/useViewPort'
import Moment from 'react-moment';
import MirsTable from "components/general/table/Table"
import { Accordion } from 'react-bootstrap'
import { ColumnDate, ColumnMedalEvent, ColumnMedalEventWithCompetitor, ColumnMedalCompetitor, ColumnDiscipline, ColumnMedal } from "components/common/schedule/TableColumns"
import { useUrlFriendlyToParameters, useNavigateTo } from 'helpers/urlFriendly';
import { getLevelRSC, getLongEventRSC } from "helpers/rsc"
import Noc from "components/presentation/Noc";
import { ColumnNoc } from "../TableColumns";
import { Header } from "components/sports/glo/brackets/generic";

const getConfiguration = (breakPoint, globalProps, eventorder) => {
  const isMobile = (breakPoint === "sm" || breakPoint === "xs")

  let configuration = {
    columns: [],
    sortBy: [],
    disableSort: false
  };

  configuration.sortBy = []

  switch (eventorder) {
    case 'DATE':
      configuration.sortBy = [{ id: 'Time', desc: false }]
      break;
    case 'LOC':
      configuration.sortBy = [{ id: 'Location', desc: false }]
      configuration.disableSort = true
      break;
  }

  configuration.columns = isMobile ? TableColumnsSM(globalProps) : TableColumns(globalProps, configuration.disableSort)

  return configuration;
};




const MedallistsTable = ({ data, eventorder }) => {
  const { breakPoint } = useViewport();
  const globalProps = useSelector(getGlobalProps)
  const config = useMemo(() => getConfiguration(breakPoint, globalProps, eventorder), [breakPoint]);
  const [paramsUrl, setParamsUrl] = useState({});
  const [shouldNavigate, setShouldNavigate] = useState(false);
  useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, 'results')//useGetURL(paramsURL, 'results')

  //Prepare URL to navigate
  const params = useUrlFriendlyToParameters()
  const { mirs_competition, mirs_language, mirs_noc } = useUrlFriendlyToParameters()
  let paramsURL = { ...params }

  const handleClick = (props) => {
    const rsc = props?.eventUnit?.code;
    if (getLevelRSC(paramsURL["mirs_rsc"]) === "EVENT") {
      paramsURL["mirs_event_rsc"] = rsc
      paramsURL["mirs_rsc"] = undefined
    } else {
      //Phase or unit
      paramsURL["mirs_event_rsc"] = getLongEventRSC(rsc)
      paramsURL["mirs_rsc"] = rsc
    }
    setParamsUrl(paramsURL);

  };



  return (

    <Accordion className='schedule-container' defaultActiveKey="0">
      <Accordion.Item eventKey="0">
        <Accordion.Header className='schedule-title'>
          <Noc />
        </Accordion.Header>
        <Accordion.Body className="p-0">

          <MirsTable
            className="table-schedule"
            data={data}
            columns={config.columns}
            keyRow='participant-code'
            initialSortBy={config.sortBy}
            rowOnClick={true}
            rowClickHandler={handleClick}
            id={`mirs-table-medallists`}
            showPagination={true}
            pageSizeCustom={10}
          />
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  )
}

export default MedallistsTable;



function TableColumns(globalProps, disableSort) {
  return (
    [
      ColumnNoc({ longDesc: true, label: "HeaderCountryNOC" }),
      ColumnMedalCompetitor({}),
      ColumnDiscipline({ label: "HeaderSport" }),
      ColumnMedalEvent({ disableSort: disableSort }),
      ColumnMedal({}),

      //ColumnDate(globalProps, { disableSort: disableSort })
    ]
  )
}

function TableColumnsSM(globalProps, disableSort) {
  return (
    [
      ColumnMedalEventWithCompetitor({}),
      ColumnDiscipline({}),
      ColumnMedal({}),

    ]
  )
}


